const ConvertStringToDate = (a) => {
  let splitDate = a.split("-");
  return new Date(splitDate[2], splitDate[1] - 1, splitDate[0]);
};

export default ConvertStringToDate;
